'use strict';

define('vb/private/stateManagement/context/fragmentExtensionContext',[
  'vb/private/stateManagement/context/containerExtensionContext',
  'vb/private/stateManagement/context/fragmentBaseContext',
], (ContainerExtensionContext, FragmentBaseContext) => {
  /**
   * Set of properties to expose in fragment extension container
   * @class
   * @extends ContainerExtensionContext
   */
  class FragmentExtensionContext extends ContainerExtensionContext {
    /**
     * BaseContextType property: The type of the baseContext object used for $base in expression.
     * This is used by super class ContainerContext to construct the baseContext object.
     */
    static get BaseContextType() {
      return FragmentBaseContext;
    }

    /**
     * see ContainerExtensionContext
     *
     * @param extension
     * @returns {Object}
     */
    static getAvailableContexts(extension) {
      const availableContexts = super.getAvailableContexts(extension);

      // Remove properties added by container context that should not be part of the
      // fragment context.
      delete availableContexts.$application;
      delete availableContexts.$metadata;

      Object.defineProperties(availableContexts, {
        $fragment: {
          enumerable: true,
          configurable: true,
          get() {
            return extension.expressionContext;
          },
        },
      });

      return availableContexts;
    }
  }

  return FragmentExtensionContext;
});

